/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Following_Empty_HintInputs */

const en_following_empty_hint = /** @type {(inputs: Following_Empty_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Follow what you work on from its page: each change of its status, or every change, reaches your notifications.`)
};

/**
* | output |
* | --- |
* | "Follow what you work on from its page: each change of its status, or every change, reaches your notifications." |
*
* @param {Following_Empty_HintInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const following_empty_hint = /** @type {((inputs?: Following_Empty_HintInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Following_Empty_HintInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_following_empty_hint(inputs)
});